import { Controller } from 'react-hook-form'

export default ({
  name,
  control,
  label,
  defaultValue = '',
  disabled = false,
  hint = "",
  validator = {},
  className = ""
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <div className="flex flex-col items-start w-full">
        <label className="label">
          { label }
        </label>
        { hint && <div className="label w-full whitespace-normal text-xs">{ hint }</div>}
        <textarea 
          className={`textarea textarea-bordered w-full ${className} ${validator.hasError ? 'validator' : ''}`} 
          {...field}
          value={field.value || ''} 
          disabled={disabled}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        />
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 pt-2 empty:py-[0.6rem]"
               style={{marginTop: '0px'}}
          >
            {validator.getErrorMessage(name)}
          </div>
        )}
      </div>
    )}
  />
)